import { createUseStyles } from 'react-jss';

import { flex } from '@styles/resources/mixins';
import { ThemeProps } from '@styles/theme';

export const useStyles = createUseStyles((theme: ThemeProps) => ({
    wrapper: {
        ...flex('row', '', 'center'),
        position: 'relative',
        minWidth: 0,
    },
    userName: {
        fontFamily: theme.font.primary,
        fontSize: 16,
        lineHeight: 1.5,
        color: '#ffffff',
        display: 'inline-block',
        marginRight: theme.spacing(4),
        [theme.down('tablet')]: {
            display: 'none',
        },
    },
    button: {
        background: 'none',
        border: 'none',
        outline: 'none',
        transformOrigin: 'center',
        transform: 'scale(1, -1)',
        transition: 'transform .2s ease',
        cursor: 'pointer',
        minWidth: 44,
        minHeight: 44,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: theme.radius,
    },
    rotated: {
        transform: 'scale(1, 1)',
    },
    dropdown: {
        position: 'absolute',
        right: 0,
        top: 52,
        width: 216,
        zIndex: 10,
        boxShadow: '0px 8px 16px 4px rgba(0, 0, 0, 0.25)',
    },
}));
